import React from 'react'

const buttonClasses =
  'px-4 py-2 rounded-md font-bold uppercase tracking-wide text-sm text-orange-600 hover:bg-orange-100 cursor-pointer'

export const OkButton = ({action}) => {
  return (
    <button type='button' onClick={action} className={buttonClasses}>
      OK
    </button>
  )
}

export const CancelButton = ({action}) => {
  return (
    <button type='button' onClick={action} className={buttonClasses}>
      Cancel
    </button>
  )
}
